import React, { useContext } from "react";

import { Headline } from "../../../components/Headline";
import { Tagline } from "../../../components/Tagline/Tagline";
import { DownloadElement } from "../../../components/DownloadElement/DownloadElement";

import * as styles from "./component.module.less";
import ElementContext from "../../../components/ElementContext";

function NestedDownloadList({
    data: { tagline, headline, semanticOfHeadline, download }
}) {
    const { isLightBg } = useContext(ElementContext);

    return (
        <div className={styles.container}>
            {tagline && (
                <Tagline hasLightBackground={isLightBg}>{tagline}</Tagline>
            )}

            {headline && (
                <Headline semanticOfHeadline={semanticOfHeadline}>
                    {headline}
                </Headline>
            )}

            <div className={styles.list}>
                {download.map(
                    ({
                        id,
                        label,
                        url,
                        file,
                        linkState,
                        isFileUrl,
                        isExternalUrl,
                        externalDownloadLink
                    }) => (
                        <DownloadElement
                            id={id}
                            label={label}
                            url={url}
                            linkState={linkState}
                            isFileUrl={isFileUrl}
                            isExternalUrl={isExternalUrl}
                            format={file?.format}
                            externalDownloadLink={externalDownloadLink}
                        />
                    )
                )}
            </div>
        </div>
    );
}

export { NestedDownloadList };
